import { useLang } from "../lang";
import { MACROS } from "../catalog";
import Tile from "../components/Tile";
import Breadcrumb from "../components/Breadcrumb";

export default function Products() {
  const { t, lang } = useLang();

  return (
    <main className="min-h-screen bg-[#f5f5f7] pt-20" data-testid="products-page">
      <div className="max-w-[1200px] mx-auto px-6 pt-8">
        <Breadcrumb items={[{ label: "Home", to: "/" }, { label: t.productsEyebrow }]} />
      </div>

      <section className="pt-8 pb-6">
        <div className="max-w-[1200px] mx-auto px-6 text-center">
          <div className="text-[13px] uppercase tracking-widest text-[#1D3F94] mb-4">{t.productsEyebrow}</div>
          <h1 className="text-[36px] md:text-[56px] font-semibold tracking-[-0.02em] text-[#1d1d1f]">
            {t.productsTitle}
          </h1>
          <p className="mt-4 text-[17px] text-[#1d1d1f]/80 max-w-[720px] mx-auto">{t.productsBody}</p>
        </div>
      </section>

      {/* Macro tiles */}
      <section className="pb-24">
        <div className="max-w-[1200px] mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {Object.values(MACROS).map((m, i) => (
            <Tile
              key={m.slug}
              to={`/prodotti/${m.slug}`}
              testId={`macro-${m.slug}`}
              image={m.image}
              title={m[lang].title}
              subtitle={m[lang].sub}
              variant="cover"
              index={i}
            />
          ))}
        </div>
      </section>

    </main>
  );
}
